import { render, staticRenderFns } from "./TreasuryReceiptPrint.vue?vue&type=template&id=6ce6ccf0&"
import script from "./TreasuryReceiptPrint.vue?vue&type=script&lang=js&"
export * from "./TreasuryReceiptPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports